export default __webpack_public_path__ + "static/media/extra-address-icon.b70c45ab.svg";